export default __webpack_public_path__ + "static/media/default.a33b48dd.jpg";